const defaultVariantMapping = {
  "DM Serif H1": "h1",
  "DM Serif H2": "h2",
  "DM Serif H3": "h3",
  "DM Serif H4": "h4",
  "DM Serif H5": "h5",
  "DM Serif Subtitle 1": "p",
  "DM Serif Subtitle 2": "p",
  "Lato H1": "h1",
  "Lato H2": "h2",
  "Lato H3": "h3",
  "Lato H4": "h4",
  "Lato H4 Bold": "h4",
  "Lato H5": "h5",
  "Lato H5 Bold": "h5",
  "Lato Emphasized 1": "p",
  "Lato Emphasized 2": "p",
  "Lato Link 1": "span",
  "Lato Link 2": "span",
  "Lato Body 1": "p",
  "Lato Body 2": "p",
  "Lato Caption": "p",
  "Lato Caption Bold": "p",
  "Lato Caption Small": "p",
  "Lato Caption Small Bold": "p",
  "Lato Button": "span",
  "Lato Overline": "p",
  "Lato Overline Bold": "p",
  "Sarabun H1": "h1",
  "Sarabun H2": "h2",
  "Sarabun H3": "h3",
  "Sarabun H4": "h4",
  "Sarabun H5": "h5",
  "Sarabun H6": "h6",
  "Sarabun Subtitle 1": "p",
  "Sarabun Subtitle 2": "p",
  "Sarabun Body 1": "p",
  "Sarabun Body 2": "p",
  "Sarabun Link 1": "span",
  "Sarabun Link 2": "span",
  "Sarabun Button": "span",
  "Sarabun Caption": "p",
  "Sarabun Overline": "p"
};
export {
  defaultVariantMapping
};
